import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25c90a84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-content" }
const _hoisted_2 = { class: "detail-container" }
const _hoisted_3 = { class: "select-wrap" }
const _hoisted_4 = { class: "swipe-wrap" }
const _hoisted_5 = { class: "operator-wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "电子证书与实体证书法律效力相同，您可按需选择是否购买实体证书。", -1))
const _hoisted_7 = { class: "info-wrap" }
const _hoisted_8 = { class: "info-label" }
const _hoisted_9 = { class: "info-value" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "实体证办理进度查询", -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, null, -1))

import { ref } from 'vue'
import { Toast } from 'vant'
import { PullRefresh, Dialog } from 'vant'
import { clearToast } from '@/utils/tools'
import { onMounted, Ref, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { downLoadCredential } from '@/apis/my-credentials'
import { useUserPermissionVerify } from '@/compositions/useUserAuthPermission'
import type { CardItemType, credentialsDetailResult } from '@/types/my-credentials'
import { GetPhotoStatus, credentialsDetail } from '@/apis/my-credentials'
import dayjs from 'dayjs'
import AppHost from '@/utils/app'
import AppHeader from '@/components/Header.vue'
import jumpIcon from '@/assets/my-credentails/jump-icon.svg'


import { defineComponent } from 'vue'
import type { SwipeInstance } from 'vant'
import { Swipe, SwipeItem, Button } from 'vant'
import {
  judgeCetifateOpearatorApplyBtnCanLight,
  judgeCetifateOpearatorDownloadBtnCanLight,
  judgeIsNewUavOperatorCertificate,
  judgeCetifateIsDiaoyunType,
} from '@/compositions/my-crendentials/index'
import CardItem from './component/card-item.vue'
import CardBgItem from './component/card-bg-item.vue'
import Decimal from 'decimal.js'

const __default__ = defineComponent({
  components: { Swipe, SwipeItem, Button, CardItem, CardBgItem },
  name: 'credentials-detail',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $router = useRouter()
const $route = useRoute()
const { beforeAuthOpenWxMiniProgramHandle } = useUserPermissionVerify()

const refreshing = ref(false)
const pageDetail: Ref<credentialsDetailResult | null> = ref(null)
const typeValue = $route.query.type || ''
async function onRefresh() {
  try {
    await initData()
  } catch (e) {
    console.log('onRefresh', e)
  }
  refreshing.value = false
}
const isFront = ref(true)
const swipeChangeHandle = (num: number) => {
  console.log('swipeChangeHandle', num)
  isFront.value = !num
}

const swithChangeHandle = (e: Event) => {
  let target = e.target as HTMLElement
  isFront.value = target.getAttribute('select-value') === 'true'
  // 触发轮播图切换
  SwipeRef.value.swipeTo(isFront.value ? 0 : 1)
}

const infoData: Ref<
  Array<{
    label: string
    value: string
    hide?: boolean
  }>
> = ref([
  {
    label: '姓名',
    value: '',
  },
  {
    label: '性别',
    value: '',
  },
  {
    label: '出生日期',
    value: '',
  },
  {
    label: '发证机构',
    value: '',
  },
  {
    label: '培训机构',
    value: '',
  },
  {
    label: '签发日期',
    value: '',
  },
  {
    label: '有效期至',
    value: '',
  },
  {
    label: '证件编号',
    value: '',
  },
])

const SwipeRef = ref<SwipeInstance>()

const cardItem = ref<CardItemType>()
const photo = ref('')
const status = ref(0)
const isCanApplyRequest = ref(1)
const isCanApplyJudge = ref(false)
const isFistLoading = ref(false)

const scale = ref(0.69)
const height = ref('229px')
scale.value = new Decimal(document.body.clientWidth).div(390).mul(0.69).toNumber()
height.value = `${new Decimal(scale.value).div(0.69).mul(229).toNumber()}px`
const applyBtnCanLight = computed(() => {
  if (!pageDetail.value) {
    return false
  }
  return judgeCetifateOpearatorApplyBtnCanLight(cardItem.value, status.value)
})
const isDiaoyunType = computed(() => {
  if (!cardItem.value) {
    return false
  }
  return judgeCetifateIsDiaoyunType(cardItem.value)
})
const downloadLoadBtnCanLight = computed(() => {
  if (!pageDetail.value) {
    return false
  }
  return judgeCetifateOpearatorDownloadBtnCanLight(cardItem.value, status.value)
})
const cardName = computed(() => {
  return `${pageDetail.value?.user_event?.category_name || ''}${
    pageDetail.value?.user_event?.card_type_name || ''
  }`
})
async function initData() {
  try {
    let result = await Promise.all([
      credentialsDetail({ type: Number($route.query.type) }),
      GetPhotoStatus(),
    ])
    let data = result[0]
    pageDetail.value = {
      ...data,
      user_event: {
        ...data.user_event,
        active: 1, //
      },
    }
    status.value = result[1].status
    photo.value = result[1].photo
    isCanApplyRequest.value = data.user_event.is_apply

    let user = data.user
    let user_event = data.user_event
    isCanApplyJudge.value = data.user_event.can_certificate_apply === 1
    cardItem.value = {
      ...data.user_event,
      name: user.name,
      birthDay: user.birthday,
      gender: user.gender,
      createTime: dayjs(user_event.event_at * 1000).format('YYYY/MM/DD'),
      validityPeriod: dayjs(user_event.expire_at * 1000).format('YYYY/MM/DD'),
      issuingAuthority: user.issuing_authority,
      id: user.code,
      cardType: user_event.card_type,
      type: user_event.type,
      isActive: !!user_event,
      active: 1, // 点亮的才会进来这个页面
      cardName: `${user_event.category_name}${user_event.card_type_name}`,
      code: user.code,
    }
    infoData.value = [
      {
        label: '姓名',
        value: data.user.name,
      },
      {
        label: '性别',
        value: data.user.gender,
      },
      {
        label: '出生日期',
        value: data.user.birthday,
      },
      {
        label: '发证机构',
        value: data.user.issuing_authority,
      },
      {
        label: '培训机构',
        value: data.user.train_authority,
      },
      {
        label: '签发日期',
        value: dayjs(data.user_event.event_at * 1000).format('YYYY/MM/DD'),
      },
      {
        label: '有效期至',
        hide: judgeIsNewUavOperatorCertificate(cardItem.value),
        value: dayjs(data.user_event.expire_at * 1000).format('YYYY/MM/DD'),
      },
      {
        label: '证件编号',
        value: data.user.code,
      },
    ]
  } catch (e) {
    console.log('initData', e)
  }
}

onMounted(async () => {
  clearToast()
  let toast = Toast({
    type: 'loading',
    message: '获取数据中...',
    forbidClick: true,
    duration: 0,
  })
  try {
    isFistLoading.value = true
    await initData()
  } catch (e) {
    console.log('onMounted')
  }
  isFistLoading.value = false
  toast.clear()
})

function leftClickHandle() {
  $router.replace({
    name: 'my-credentials-detail',
  })
}

function jumpHandle() {
  $router.push({
    name: 'credentials-progress-search',
  })
}

function applyHandle() {
  // 判断是否有申请过
  if (isCanApplyRequest.value === 1) {
    Dialog.alert({
      title: '提示',
      className: 'tip-dialog',
      message: '您有尚在申请制证或制作中的证件，无需重复申请。',
      confirmButtonColor: 'rgba(0, 195, 120, 1)',
      confirmButtonText: '知道了',
    })
    return
  }
  beforeAuthOpenWxMiniProgramHandle({
    id: 'gh_68b32d3107f6',
    path: `/pages--train/my_license_apply_form?type=${Number($route.query.type)}`,
    version: process.env.NODE_ENV === 'production' ? 0 : 1,
  })
}

const downLoadHandle = async () => {
  let toast = Toast({
    type: 'loading',
    message: '下载中...',
    forbidClick: true,
    duration: 0,
  })
  try {
    let url = ''
    if (judgeIsNewUavOperatorCertificate(cardItem.value)) {
      url = cardItem.value.license_seal_image_url
    } else {
      let data = await downLoadCredential({
        type: cardItem.value.type,
      })
      url = data.file_url
    }
    console.log(url)
    AppHost.openBrowser(url, true)
    toast.clear()
  } catch (e: any) {
    console.log(e)
    Toast.fail(e.message)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "证件详情",
      isReturnLeftEvent: true,
      onLeftClick: leftClickHandle
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(PullRefresh), {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refreshing).value = $event)),
        onRefresh: onRefresh,
        class: "detail-wrap"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "select-inner",
                onClick: swithChangeHandle
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass({ active: isFront.value }),
                  "select-value": "true"
                }, "正面", 2),
                _createElementVNode("div", {
                  class: _normalizeClass({ active: !isFront.value }),
                  "select-value": "false"
                }, "反面", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Swipe), {
                class: "my-swipe",
                "show-indicators": false,
                onChange: swipeChangeHandle,
                ref_key: "SwipeRef",
                ref: SwipeRef
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(SwipeItem), null, {
                    default: _withCtx(() => [
                      _createVNode(CardItem, {
                        cardItem: cardItem.value,
                        scale: scale.value,
                        status: status.value,
                        photo: photo.value,
                        height: height.value,
                        needCalc: ""
                      }, null, 8, ["cardItem", "scale", "status", "photo", "height"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(SwipeItem), null, {
                    default: _withCtx(() => [
                      _createVNode(CardBgItem, {
                        cardItem: cardItem.value,
                        cardName: _unref(cardName),
                        type: pageDetail.value?.user_event?.card_type || '',
                        scale: scale.value,
                        height: height.value
                      }, null, 8, ["cardItem", "cardName", "type", "scale", "height"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(Button), {
                class: _normalizeClass(["btn", { active: _unref(applyBtnCanLight) }]),
                disabled: !_unref(applyBtnCanLight),
                onClick: applyHandle
              }, {
                default: _withCtx(() => [
                  _createTextVNode("申请实体证件")
                ]),
                _: 1
              }, 8, ["class", "disabled"]),
              _createVNode(_unref(Button), {
                class: _normalizeClass(["btn", { active: _unref(downloadLoadBtnCanLight) }]),
                disabled: !_unref(downloadLoadBtnCanLight),
                onClick: downLoadHandle
              }, {
                default: _withCtx(() => [
                  _createTextVNode("下载电子证")
                ]),
                _: 1
              }, 8, ["class", "disabled"])
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infoData.value, (item, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["info-item", { 'van-hairline--top': index }]),
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(item.label), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item.value), 1)
                ], 2)), [
                  [_vShow, !item.hide]
                ])
              }), 128))
            ]),
            (!_unref(isDiaoyunType))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "jump-progress-wrap",
                  onClick: jumpHandle
                }, [
                  _hoisted_10,
                  _createElementVNode("img", { src: _unref(jumpIcon) }, null, 8, _hoisted_11)
                ]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, !isFistLoading.value]
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _hoisted_12
  ], 64))
}
}

})